import React from 'react';

const W8CertificationDeclaration = () => {
  return (
    <div className="d-flex gap-3 mb-4 notice_card">
      <div className="w-full">
        <p>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</p>
        <ul>
          <li>I am the individual that is the beneficial owner (or am authorized to sign for the individual that is the beneficial owner) of all the income or proceeds to which this form relates or am using this form to document myself for chapter 4 purposes;</li>
          <li>The person named on line 1 of this form is not a U.S. person;</li>
          <li>This form relates to:
            <ul>
              <li>(a) income not effectively connected with the conduct of a trade or business in the United States;</li>
              <li>(b) income effectively connected with the conduct of a trade or business in the United States but is not subject to tax under an applicable income tax treaty;</li>
              <li>(c) the partner's share of a partnership's effectively connected taxable income; or</li>
              <li>(d) the partner's amount realized from the transfer of a partnership interest subject to withholding under section 1446(f);</li>
            </ul>
          </li>
          <li>The person named on line 1 of this form is a resident of the treaty country listed on line 9 of the form (if any) within the meaning of the income tax treaty between the United States and that country; and</li>
          <li>For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.</li>
        </ul>
        <p>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which I am the beneficial owner or any withholding agent that can disburse or make payments of the income of which I am the beneficial owner. I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</p>
      </div>
    </div>
  );
};

export default W8CertificationDeclaration;
